// defines all the interests that can be displayed including subcategories
// p = picture
// t = title
// s = selected
// o = opened
// each i is an absolute id that *CAN NOT* be changed once put into production.

/*
h: head = 0 is title, 1 is selectable entry
module.exports = [
  { h: 0, t: "Nightlife", i: 0 },
  { h: 1, p: "bar", t: "Bars", s: false, i: 0, },
  { h: 1, p: "parties", t: "Parties", s: false, i: 1, },
  { h: 1, p: "night_clubs", t: "Night Clubs", s: false, i: 2, },
  { h: 1, p: "concerts_live_shows", t: "Concerts/Live Shows", s: false, i: 3, },
  { h: 1, p: "raves", t: "Raves", s: false, i: 4, },
  { h: 1, p: "stand_up_comedy", t: "Stand Up Comedy", s: false, i: 5, },
  { h: 1, p: "dance", t: "Dancing", s: false, i: 6, },
]
*/

module.exports.items = [
  {
    p: "night_life",
    t: "Nightlife",
    i: 0,
    o: false,
    subCategories: [
      // {
      //   p: "", // pic
      //   t: "", // text
      //   s: false, i: , // selected
      // },
      
      { p: "bar", t: "Bars", s: false, i: 0, },
      { p: "parties", t: "Parties", s: false, i: 1, },
      { p: "night_clubs", t: "Night Clubs", s: false, i: 2, },
      { p: "concerts_live_shows", t: "Concerts/Live Shows", s: false, i: 3, },
      { p: "raves", t: "Raves", s: false, i: 4, },
      { p: "stand_up_comedy", t: "Stand Up Comedy", s: false, i: 5, },
      { p: "dance", t: "Dancing", s: false, i: 6, },
    ]
  },
  
  {
    p: "performing_arts",
    t: "Performing Arts",
    i: 1,
    o: false,
    subCategories: [
    ]
  },
  
  {
    p: "sports",
    t: "Sports",
    i: 2,
    o: false,
    subCategories: [
      { p: "rockclimbing", t: "Rockclimbing", s: false, i: 7, },
      { p: "skiing_snowboarding", t: "Ski/Snowboarding", s: false, i: 8, },
      { p: "soccer", t: "Soccer", s: false, i: 9, },
      { p: "tennis", t: "Tennis", s: false, i: 10, },
      { p: "basketball", t: "Basketball", s: false, i: 11, },
      { p: "cycling", t: "Cycling", s: false, i: 12, },
      { p: "martial_arts", t: "Martial Arts", s: false, i: 13, },
      { p: "bowling", t: "Bowling", s: false, i: 14, },
      { p: "table_tennis", t: "Table Tennis", s: false, i: 15, },
      { p: "motorbiking", t: "Motorbiking", s: false, i: 16, },
      { p: "american_football", t: "American Football", s: false, i: 17, },
      { p: "baseball", t: "Baseball", s: false, i: 18, },
      { p: "golf", t: "Golf", s: false, i: 19, },
      { p: "volleyball", t: "Volleyball", s: false, i: 20, },
      { p: "running", t: "Running", s: false, i: 21, },
      { p: "boxing", t: "Boxing", s: false, i: 22, },
      { p: "hockey", t: "Hockey", s: false, i: 23, },
      { p: "weight_lifting", t: "Weight Lifting", s: false, i: 24, },
      { p: "dance", t: "Dance", s: false, i: 25, },
      { p: "pool", t: "Pool", s: false, i: 26, },
      { p: "darts", t: "Darts", s: false, i: 27, },
      { p: "skydiving", t: "Skydiving", s: false, i: 28, },
      { p: "bungee_jumping", t: "Bungee Jumping", s: false, i: 29, },
      { p: "paragliding", t: "Paragliding", s: false, i: 30, },
      { p: "archery", t: "Archery", s: false, i: 31, },
      { p: "ultimate_frisbee", t: "Ultimate Frisbee", s: false, i: 32, },
      { p: "poker", t: "Poker", s: false, i: 33, },
      { p: "pickleball", t: "Pickleball", s: false, i: 71, },
    ]
  },
  
  {
    p: "the_outdoors",
    t: "The Outdoors",
    i: 3,
    o: false,
    subCategories: [
      { p: "hiking", t: "Hiking", s: false, i: 34, },
      { p: "camping", t: "Camping", s: false, i: 35, },
      { p: "fishing", t: "Fishing", s: false, i: 36, },
      { p: "mountain_biking", t: "Mountain Biking", s: false, i: 37, },
      { p: "gardening", t: "Gardening", s: false, i: 38, },
      { p: "rockclimbing", t: "Rockclimbing", s: false, i: 39, },
      { p: "swimming", t: "Swimming", s: false, i: 40, },
      { p: "running", t: "Running", s: false, i: 41, },
      { p: "photography", t: "Photography", s: false, i: 42, },
      { p: "hunting", t: "Hunting", s: false, i: 43, },
      { p: "skiing_snowboarding", t: "Ski/Snowboarding", s: false, i: 44, },
      { p: "yoga", t: "Yoga", s: false, i: 45, },
      { p: "caving", t: "Caving", s: false, i: 46, },
      { p: "horseback_riding", t: "Horseback Riding", s: false, i: 47, },
      { p: "motorbiking", t: "Motorbiking", s: false, i: 48, },
      { p: "paintball", t: "Paintball", s: false, i: 49, },
      { p: "rollerskating", t: "Rollerskating", s: false, i: 50, },
      { p: "ice_skating", t: "Ice Skating", s: false, i: 51, },
    ]
  },
  
  {
    p: "water_adventures",
    t: "Water Adventures",
    i: 4,
    o: false,
    subCategories: [
      { p: "snorkeling", t: "Snorkeling", s: false, i: 52, },
      { p: "surfing", t: "Surfing", s: false, i: 53, },
      { p: "paddleboarding", t: "Paddleboarding", s: false, i: 54, },
      { p: "kayaking", t: "Kayaking", s: false, i: 55, },
      { p: "swimming", t: "Swimming", s: false, i: 56, },
      { p: "scuba_diving", t: "Scuba Diving", s: false, i: 57, },
      { p: "cliff_jumping", t: "Cliff Jumping", s: false, i: 58, },
      { p: "jet_skiing", t: "Jet Skiing", s: false, i: 59, },
      { p: "fishing", t: "Fishing", s: false, i: 60, },
      { p: "water_skiing", t: "Water Skiing", s: false, i: 61, },
      { p: "sailing", t: "Sailing", s: false, i: 62, },
      { p: "rafting", t: "Rafting", s: false, i: 63, },
      { p: "kitesurfing", t: "Kitesurfing", s: false, i: 64, },
      { p: "canoeing", t: "Canoeing", s: false, i: 65, },
      { p: "underwater_photography", t: "Underwater Photography", s: false, i: 66, },
      { p: "rowing", t: "Rowing", s: false, i: 67, },
      { p: "windsurfing", t: "Windsurfing", s: false, i: 68, },
      { p: "cave_diving", t: "Cave Diving", s: false, i: 69, },
      { p: "spearfishing", t: "Spearfishing", s: false, i: 70, },
    ]
  },
  
]


let cache = [];
module.exports.convert = function() {
  
  if (cache.length == 0) {
    let items = module.exports.items;
    // console.log("items:", items);
    
    let out = [];
    
    for (let i in items) {
      
      if (items[i].subCategories.length > 0) {
        
        out.push( { h: 0, t: items[i].t, } );
        
        let subs = items[i].subCategories.sort(sortFunction);
      
        for (let j in subs) {
          out.push( { h: 1, t: subs[j].t, p: subs[j].p, s: false, i: subs[j].i, } );
        }
          
      }
      
    }
    
    // console.log("out:", out);
    
    cache = out;
    return out;
    
  } else {
    return cache;
  }
  
}


function sortFunction(a, b) {
  let nameA = a.t.toUpperCase(); // ignore upper and lowercase
  let nameB = b.t.toUpperCase(); // ignore upper and lowercase
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }

  // names must be equal
  return 0;
}

